import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppAuth } from '@/contexts/app-auth.context'
import { getDefaultDashboardRoute } from '@/lib/utils/get-default-dashboard-route'
import { Loader } from '@/components/ui/loader'
import { toast } from 'sonner'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { user, isAuthLoading } = useAppAuth()

  useEffect(() => {
    const handleCallback = async () => {
      // Check for error in URL params
      const error = searchParams.get('error')
      if (error) {
        const errorDescription =
          searchParams.get('error_description') || 'Authentication failed'
        toast.error(errorDescription)
        navigate('/sign-in')
        return
      }

      // Wait for auth to complete
      if (!isAuthLoading && user) {
        // Get the return path from state or default to feature-flag-based dashboard
        const state = searchParams.get('state')
        let returnPath: string

        if (state) {
          try {
            const stateData = JSON.parse(atob(state))
            returnPath = stateData.returnPath || getDefaultDashboardRoute(true)
          } catch {
            returnPath = getDefaultDashboardRoute(true)
          }
        } else {
          returnPath = getDefaultDashboardRoute(true)
        }

        navigate(returnPath)
      }
    }

    if (!isAuthLoading) {
      handleCallback()
    }
  }, [isAuthLoading, user, navigate, searchParams])

  return (
    <div className="h-screen overflow-hidden bg-black">
      <div className="flex min-h-screen items-center justify-center text-white">
        <Loader text="Checking authentication..." className="text-white" />
      </div>
    </div>
  )
}
